export class BookHelper {
    static getBookDiscount(discountType, price, oldprice, defaultValue) {
        if(typeof price == 'string') price = price.replaceAll(' ', '');
        if(typeof oldprice == 'string') oldprice = oldprice.replaceAll(' ', '');
        
        let tempDiscountQuantity = defaultValue;
        switch (parseInt(discountType)) {
            case 1: // %
                tempDiscountQuantity = Math.round((1 - parseInt(price) / parseInt(oldprice)) * 100);
                break;
            case 2: // Fix price
                tempDiscountQuantity = price;
                break;
        
            default:
                break;
        }

        return tempDiscountQuantity;
    }

    static getIsPriceCapped(releaseDateParam, type) {
        const currentDate = new Date();
        const releaseDate = new Date(releaseDateParam);

        return releaseDate.getTime() > currentDate.setFullYear(currentDate.getFullYear() - 1) && // Check if its older then 1 yo
            releaseDate.getTime() > new Date('2024-10-01 00:00:00') && // Where the price cap started
            (type == 1 || type == 2); // Only for ebooks, audiobooks
    }
};
